// App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import GeneralLoginPage from './pages/login';
import GymCertificationForm from './pages/certificatePage';
import AdminProductPage from './pages/adminProduct';
import UserProductSelectionPage from './pages/userProduct';
import AdminSubmissionPage from './pages/submission';
import AdminLoginPage from './pages/adminLogin';
import { AdminRoute, UserRoute } from './protectedRoutes';
import SignupPage from './pages/signup';
import NotApprovedPage from './pages/notApproved';
import AdminUsersPage from './pages/users'
import CertificateSelectionPage from './pages/CertificateSelectionPage';

function App() {


  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<GeneralLoginPage />} />
          <Route path="/signup" element={<SignupPage/>} />
          <Route path="/notApproved" element={<NotApprovedPage/>} />
          <Route path="/login/admin" element={<AdminLoginPage />} />
          <Route path="/certificate/:category" element={<GymCertificationForm />} />
          <Route path="/certificate" element={<GymCertificationForm />} />
          <Route path="/certificateSelection" element={<CertificateSelectionPage />} />

          {/* Admin Protected Routes */}
          <Route 
            path="/admin/product" 
            element={
              <AdminRoute>
                <AdminProductPage />
              </AdminRoute>
            } 
          />
          <Route 
            path="/admin/submission" 
            element={
              <AdminRoute>
                <AdminSubmissionPage />
              </AdminRoute>
            } 
          />
          <Route 
            path="/admin/users" 
            element={
              <AdminRoute>
                <AdminUsersPage />
              </AdminRoute>
            } 
          />

          {/* User Protected Route */}
          <Route 
            path="/user/product" 
            element={
              <UserRoute>
                <UserProductSelectionPage />
              </UserRoute>
            } 
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
